import Swiper, { Keyboard, SwiperOptions, Navigation } from "swiper";

const setsSliders = document.querySelectorAll<HTMLElement>(".g-sets-slider")

setsSliders.forEach(slider => {

  const swiperSettings: SwiperOptions = {
    modules: [Keyboard, Navigation],
    slidesPerView: 1,
    spaceBetween: 1,
    watchSlidesProgress: true,
    keyboard: {
      enabled: true,
    },
    navigation: {
      nextEl: slider.querySelector<HTMLElement>(".swiper-button-next"),
      prevEl: slider.querySelector<HTMLElement>(".swiper-button-prev"),
    },
    breakpoints: {
      767: {
        slidesPerView: 2,
      },
      1200: {
        slidesPerView: 3,
      },
    },
  }

  new Swiper(slider, swiperSettings)

})
